import { BehaviorSubject } from 'rxjs';
import { TableVirtualScrollDataSource } from 'ng-om-table-virtual-scroll';
import { FormControl } from '@angular/forms';
import { MapBaseComponent } from 'src/app/view-shared/map-base/map-base.component';
import { TableBaseComponent } from 'src/app/view-shared/table-base/table-base.component';
import {
	IOverlay,
	IOverlayIndexed,
	BaseLayer,
	IMapBounds
} from '../view-shared/map-base/map-base.models';
import { IPointGroup } from '../view-routes/inside/admin/point-groups/point-group.models';
import { ChartBrowserComponent } from '../view-shared/chart-browser/chart-browser.component';
import { GraphRow } from '../view-shared/chart-browser/chart-browser.models';
import { Note } from '../view-shared/notes/notes.models';
import { MatTableDataSource } from '@angular/material/table';
import { Type } from '@angular/core';

// - - -

export enum EMapFeatures {
	RadarCtrl = 'radarCtrl',
	MeasureCtrl = 'measureCtrl',
	SearchCtrl = 'searchCtrl',
	ScaleCtrl = 'scaleCtrl'
}

export enum EStopLightColor {
	DANGER = 'red',
	WARNING = 'yellow',
	OK = 'green',
	IDLE = 'idle',
	UNKNOWN = 'grey'
}

export interface IDateRange {
	begin: number;
	end: number;
}

export interface ITableFilter {
	byString: string;
	byActive: boolean;
	byParameters: number[];
	byPointGroups: number[];
	byTypes: string[];
	byHealthTypes: string[];
	bySensorHubTypes: number[];
	displayedColumns: string[];
}

export class DialogDataDeprecated {
	message: string;
	state: 'normal' | 'warning' | 'error' | 'success' | 'spinner' = 'normal';
	closeBtn: boolean = false;
}

/**
 * common statestore for view-routes, usually declared in their service
 */
export interface IStateStore {
	initialized: boolean;
	$currentRow: BehaviorSubject<GraphRow>;
	pointNotes: Note[];
	splitState: 'l' | 'c' | 'r' | 'u';
	tabIndex: number;
	rows: TableVirtualScrollDataSource<any> | MatTableDataSource<any>; // DataInspectorRow
	filterByString?: FormControl;
	filterByParameters?: FormControl;
	filterByTypes?: FormControl;
	filterByHealthTypes?: FormControl;
	filterBySensorHubTypes?: FormControl;
	filterByPointGroups?: FormControl;
	filterByActive?: FormControl;
	filterByDeviceParams?: FormControl;
	//
	filteredParameters?: number[]; // parameters from the selected parameters-groups
	filteredPoints?: number[]; // points from the selected point-groups

	pageTitlePath?: string;
	tableTitlePath?: string;
	tableColumns?: {
		[key: string]: {
			minWidth?: string; // '80%', '170px' ...
			hidden?: boolean;
			translatePath?: string;
			exludeFromSpreadsheetExport?: boolean;
			sortOn?: string; // sortOn another table column name
		};
	};
	tableColumnSort?: string;
	tableColumnSortDirection?: 'asc' | 'desc';
	tableRendering?: BehaviorSubject<'virtual' | 'all'>;
	//
	componentRef?: IComponentRef;
	//
	disableVirtualPoints?: boolean;
}
export interface IComponentRef {
	map?: MapBaseComponent;
	table?: TableBaseComponent;
	charts?: ChartBrowserComponent;
	rowComponent?: Type<any>;
}

/**
 * store misc. global states
 */
export interface IGlobalStateStore {
	lensLogoSource: string;
	drypLogoSource: string;
	appTitle: string;
	backdrop: BehaviorSubject<boolean>;
	didLogOut: boolean;
	$dateRange: BehaviorSubject<IDateRange>; // begin & end in milliseconds
	$dateTime: BehaviorSubject<number>; // current timestamp in milliseconds
	$dateLive: BehaviorSubject<boolean>;
	$dateReload: BehaviorSubject<boolean>;
	$screenWidth: BehaviorSubject<number>;
	$plotMouseTrackingEnabled: BehaviorSubject<boolean>;
	mapBoundsDefault: L.LatLngBounds;
	mapBoundsCurrent: BehaviorSubject<IMapBounds>;
	//
	mainMenu: boolean;
	public: boolean;
	showFilters: boolean;
	batchInitDateTimeUtcMilliseconds: number;
}



/**
 * Store user settings - logged in or otherwise
 * can be modified by a loaded template
 */
export interface IGlobalUserStore {
	$appMenu: BehaviorSubject<string>; // is main nav collapsed or not
	$appRoute: BehaviorSubject<string>; // current main-nav route
	$appLanguage: BehaviorSubject<string>; // two-letter language-string
	$appTimezone: BehaviorSubject<string>; // UTC or local timezone-string
	//
	filterPointGroups: FormControl;
	// filterParameterIds: FormControl;
	filterByMediaTypes: FormControl;
	filterActive: FormControl;
	filterDeviceParams: FormControl;
	$filterSensors: BehaviorSubject<number[]>;
	//
	$chartAutoScale: BehaviorSubject<boolean>;
	$chartShowFlags: BehaviorSubject<boolean>;
	$chartShowFlagsSystem: BehaviorSubject<boolean>;
	$showDefaultAnnotations: BehaviorSubject<boolean>;
	$chartShowThresholds: BehaviorSubject<boolean>;
	$chartDataType: BehaviorSubject<
		| 'raw'
		| /* 'filtered' | */ 'adjusted'
		| 'rawsub'
		| /* 'filteredsub' | */ 'adjustedsub'
	>;
	$chartUnitsMerge: BehaviorSubject<boolean>;
	$chartHeight: BehaviorSubject<'small' | 'medium' | 'large' | 'max'>;
	$chartYaxis: BehaviorSubject<boolean>;
	$chartGrouping: BehaviorSubject<'param' | 'point' | 'combine' | 'split'>;
	//
	$mapTooltip: BehaviorSubject<boolean>; // show chart values on map-marker true/false
	$mapBase: BehaviorSubject<string>; // enabled base-map name
	$mapOverlays: BehaviorSubject<string[]>; // enabled overlay names
	$mapSliderRange: BehaviorSubject<number>;
	$mapTabDefault: BehaviorSubject<boolean>; // map-view prefered true/false
	radarOpacityToggle: FormControl;
	radarAccumulationMinuteSelected: FormControl;
	//
	$parameterScale: BehaviorSubject<{ parameterId: number; unitId: number }[]>;
}


